/*
 * @Author: your name
 * @Date: 2021-05-25 16:30:33
 * @LastEditTime: 2021-10-09 15:04:44
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '../store/index'
// import * as api from '../src/common/http/request'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n/i18n'
import Bridge from '../src/common/http/jsBridge'
import * as VueGoogleMaps from 'vue2-google-maps'
// import VConsole from 'vconsole'

import Vant, { Locale } from 'vant'
import 'vant/lib/index.css'
// 引入英文语言包
import thTH from 'vant/es/locale/lang/th-TH'

Locale.use('th-TH', thTH)

Vue.use(Vant)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCwVBI8c3YBha3lkhj14iVkFpH8T5G057g',
    libraries: 'places',
    region: 'TH', // 这个地区自己定
    language: 'th' // 这个语言自己定
  },
  installComponents: true
})
// let vConsole = new VConsole()
// console.log(vConsole)
// Vue.use(ElementUI)
Vue.config.productionTip = false
// Vue.prototype.$API = api.api
Vue.prototype.$bridge = Bridge
// Vue.prototype.$qs = qs
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js